import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const Partner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const Title = styled.h3`
  font-weight: normal;
  font-size: 1.5rem;
  color: #9F9F9F;
  text-transform: uppercase;
`

export const LogoImage = styled.img`
  width: 60%;
  margin-top: 2vh
`

export const Support = styled.div`
  margin-top: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`